export const PREFIX = {
  D_MARKETING_PREFIX: "digital-marketer",
  SUPPORT_PREFIX: "support",
  TEACHER_PREFIX: "teacher",
  OPERATOR_PREFIX: "operator",
  STARTUP_PREFIX: "startup",
  ADMISSION_ASSURED_PREFIX: "admission-assured",
  WHATSAPP_PREFIX: "",
  IDCARD_PREFIX: "",
  WEBINAR_PREFIX: "webinar",
  VIDEO_PREFIX: "video"
}

export const PATH = {
  PATH_FOR_DIGITAL_MARKETING: '/v2',
  PATH_FOR_AI_SUPPORT: '/v2',
  PATH_FOR_TEACHER: '/v2',
  PATH_FOR_OPERATOR: '/v2',
  PATH_FOR_STARTUP: '/v2/startup',
  PATH_FOR_WHATSAPP: '/v2/whatsapp',
  PATH_FOR_ID_CARDS: '/v2/id-cards',
  PATH_FOR_ABOUT_US: '/v2/about-us',
  PATH_FOR_CONTACT_US: '/v2/contact-us',
  PATH_FOR_ALL: "*",
};

export const STG_BASE = 'https://api-dev.soomuch.ai/api/v1';
export const DEV_BASE = 'https://api-dev.soomuch.ai/api/v1';

export const API_HOST = 'https://api-dev.soomuch.ai/api/v1';

export const API_CONSTANT_ONBOARDING = STG_BASE;

// Where school staff actually sign in. One origin per environment:
//   dev      https://portal-dev.soomuch.ai
//   stg/prod https://portal.soomuch.ai
export const PORTAL_ORIGIN =
  process.env.REACT_APP_PORTAL_ORIGIN || 'https://portal-dev.soomuch.ai'; //Add REACT_APP_PORTAL_ORIGIN in env

export const renderBaseUrlForApi = () => {
  return window.location.pathname.startsWith("/old/onboarding") ? API_CONSTANT_ONBOARDING : DEV_BASE
}

export const generateUniqueId = () => (performance.now().toString(36) + Math.random().toString(36).slice(2, 10));

export async function getIPAddress() {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
    return null;
  }
}

export const isImageUrl = (url) => {
  if (!url) return false;

  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.tiff', '.svg'];
  const lowerUrl = url.toLowerCase().split('?')[0]; // remove query params

  return imageExtensions.some(ext => lowerUrl.endsWith(ext));
};

export const languageObject = {
  "english": "",
  "telugu": "-tel",
  "hindi": "-hin"
}

export function insertLanguageInUrl(url, language) {
  // Find the last dot to get the file extension
  const lastDotIndex = url.lastIndexOf('.');
  if (lastDotIndex === -1) return url; // No extension found

  // Insert the language before the extension
  const newUrl = url.slice(0, lastDotIndex) + `${languageObject?.[language]}` + url.slice(lastDotIndex);
  return newUrl;
}

export const PATHS = [
  '/explore',
  '/explore/how-to-achive',

  '/explore/website/image-enhancement',
  // '/explore/website/text-generator',
  '/explore/website/launch-website',

  '/explore/social-hub/stay-ahead-with-ai',
  "/explore/social-hub/social-hub-boost-engagement",

  '/explore/chatbot',

  '/explore/communication/poor-comm',
  // '/explore/communication/the-solution',
  '/explore/communication/communication-id',

  // '/explore/benefits/parent-referrals',
  '/explore/benefits/homework',
  '/explore/benefits/school-managment',

  '/explore/checkout-live-website'
];
